import React from "react";
import { FilterTuple } from "../types";
import { XMarkIcon } from "@heroicons/react/24/outline";

interface FilterChipsProps {
  filters: FilterTuple[];
  onRemove: (key: string) => void;
  onResetAll: () => void;
}

export const FilterChips: React.FC<FilterChipsProps> = ({
  filters,
  onRemove,
  onResetAll,
}) => {
  if (filters.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 animate-in fade-in slide-in-from-top-2 duration-300">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="h-1 w-1.5 bg-gradient-to-b from-indigo-500 to-purple-600 rounded-full"></div>
          <h4 className="text-xs font-semibold text-gray-700">
            Active Filters
          </h4>
          <span className="px-1.5 py-0.5 bg-indigo-100 text-indigo-700 rounded text-xs font-semibold">
            {filters.length}
          </span>
        </div>
        <button
          onClick={onResetAll}
          className="text-xs text-gray-600 hover:text-red-600 hover:bg-red-50 px-2.5 py-1 rounded-md font-medium transition-all duration-200"
          aria-label="Clear all filters"
        >
          Clear All
        </button>
      </div>
      <div className="flex flex-wrap gap-2">
        {filters.map((filter, index) => (
          <div
            key={`${filter.key}-${index}`}
            className="group inline-flex items-center gap-1.5 bg-indigo-50 text-indigo-800 px-3 py-1.5 rounded-md text-xs font-medium shadow-sm hover:bg-indigo-100 transition-all duration-200 border border-indigo-200/60"
          >
            <span className="flex items-center gap-1.5">
              <span className="w-1 h-1 bg-indigo-500 rounded-full"></span>
              {filter.display}
            </span>
            <button
              onClick={() => onRemove(filter.key)}
              className="ml-0.5 hover:bg-indigo-200 rounded p-0.5 transition-all duration-150 hover:rotate-90 focus:outline-none focus:ring-1 focus:ring-indigo-400"
              aria-label={`Remove filter ${filter.display}`}
            >
              <XMarkIcon className="h-3 w-3 text-indigo-700" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
